import { dispatch, registerEffectHandler } from 'reffects';

export function registerCacheEffects(cache) {
  registerEffectHandler(
    'cache.set',
    function setCacheKey({ key, value, config = {} }) {
      cache.set(key, value, config);
    }
  );

  registerEffectHandler(
    'cache.get',
    function getCacheKey({
      key,
      hitEvent,
      missEvent = undefined,
      extraPayload = {},
    }) {
      cache.get(key).then((value) => {
        if (undefined === value && undefined !== missEvent) {
          dispatch({ id: missEvent, payload: { key, extra: extraPayload } });
          return;
        }

        dispatch({
          id: hitEvent,
          payload: { key, value, extra: extraPayload },
        });
      });
    }
  );

  registerEffectHandler('cache.delete', function deleteCacheKeys({ keys }) {
    keys.forEach((key) => {
      cache.delete(key);
    });
  });

  registerEffectHandler('cache.clear', function clearCache() {
    cache.clear();
  });
}

function cacheSet({ key, value, config = {} }) {
  return {
    'cache.set': { key, value, config },
  };
}

function cacheGet({ key, hitEvent, missEvent = undefined, extraPayload = {} }) {
  return {
    'cache.get': { key, hitEvent, missEvent, extraPayload },
  };
}

function cacheDelete({ keys }) {
  return {
    'cache.delete': { keys },
  };
}

function cacheClear() {
  return {
    'cache.clear': {},
  };
}

export default {
  set: cacheSet,
  get: cacheGet,
  delete: cacheDelete,
  clear: cacheClear,
};
